<template>
    <div>
        <portal to="credit-card-payment-tab">
            <div class="checkout__card-tab" :class="{ apple_pay_active: applePayAvailable && paymentType == 'now' }">
                <span class="checkout__card-icons">
                    <img
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
                        data-src="https://images.iphonephotographyschool.com/32292/visa.svg"
                        class="lazy checkout__card-icon"
                        id="checkout__card-icon-visa"
                        :class="[!cardType || cardType === 'visa' ? '' : 'grayscale']"
                        alt="Visa" />
                    <img
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
                        data-src="https://images.iphonephotographyschool.com/32291/master.svg"
                        class="lazy checkout__card-icon"
                        id="checkout__card-icon-master"
                        :class="[!cardType || cardType === 'master-card' ? '' : 'grayscale']"
                        alt="MasterCard" />
                    <img
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
                        data-src="https://images.iphonephotographyschool.com/32289/discover.svg"
                        class="lazy checkout__card-icon"
                        id="checkout__card-icon-discover"
                        :class="[!cardType || cardType === 'discover' ? '' : 'grayscale']"
                        alt="Discover"
                        v-show="isCardSupported('discover')" />
                    <img
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
                        data-src="https://images.iphonephotographyschool.com/32288/amex.svg"
                        class="lazy checkout__card-icon"
                        id="checkout__card-icon-amex"
                        :class="[!cardType || cardType === 'american-express' ? '' : 'grayscale']"
                        alt="American Express"
                        v-show="cardType !== 'maestro' && isCardSupported('american-express')" />
                    <img
                        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
                        data-src="https://images.iphonephotographyschool.com/32304/maestro.svg"
                        class="lazy checkout__card-icon lazy"
                        id="checkout__card-icon-maestro"
                        :class="[!cardType || cardType === 'maestro' ? '' : 'grayscale']"
                        alt="Maestro"
                        v-show="cardType === 'maestro'" />
                </span>
            </div>
        </portal>

        <div class="checkout__input-block checkout__input-block--card">
            <div class="hosted-field" id="card-number" :style="fields.number.style" ref="hostedFieldCardNumber"></div>
            <label
                id="card-number-label"
                :style="fields.number.label.style"
                :class="fields.number.label.classObject"
                class="hosted-field--label"
                for="card-number"
                >{{ fields.number.label.text }}</label
            >
        </div>
        <div class="row">
            <div class="col-xs-6" style="padding-right: 8px">
                <div class="checkout__input-block checkout__input-block--card">
                    <div
                        class="hosted-field"
                        id="expiration-date"
                        :style="fields.expirationDate.style"
                        ref="hostedFieldExpirationDate"></div>
                    <label
                        id="exp-date-label"
                        class="hosted-field--label"
                        :style="fields.expirationDate.label.style"
                        :class="fields.expirationDate.label.classObject"
                        for="expiration-date-label"
                        v-html="fields.expirationDate.label.text">
                    </label>
                </div>
            </div>
            <div class="col-xs-6" style="padding-left: 8px">
                <div class="checkout__input-block checkout__input-block--card">
                    <div class="hosted-field" id="cvv" :style="fields.cvv.style" ref="hostedFieldCvv"></div>
                    <label
                        class="hosted-field--label"
                        id="cvv-label"
                        :style="fields.cvv.label.style"
                        :class="fields.cvv.label.classObject"
                        for="cvv"
                        >{{ fields.cvv.label.text }}</label
                    >

                    <p
                        v-show="cardType === 'american-express'"
                        class="cvv__help-text cvv_help-4-digits"
                        style="display: none"
                        v-html="$t('checkout.creditCardCheckFront')"></p>
                    <img
                        v-show="cardType === 'american-express'"
                        src="data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 1 1\'></svg>"
                        data-src="https://cdn.iphonephotographyschool.com/cdn/sales/amex-front.png"
                        class="lazy cvv__help-img cvv_help-4-digits"
                        style="display: none"
                        alt="" />

                    <p
                        v-show="cardType !== 'american-express'"
                        class="cvv__help-text cvv_help-3-digits"
                        v-html="$t('checkout.creditCardCheckBack')"></p>
                    <img
                        v-show="cardType !== 'american-express'"
                        src="data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 1 1\'></svg>"
                        data-src="https://cdn.iphonephotographyschool.com/cdn/sales/visa-back.png"
                        class="lazy cvv__help-img cvv_help-3-digits"
                        alt="" />
                </div>
            </div>
        </div>
        <div v-if="!creditCardAvailable" class="checkout__payment-block-loader">
            <span class="checkout__processing-text">
                <span class="glyphicon glyphicon-refresh glyphicon-spin"></span>
            </span>
        </div>

        <portal to="credit-card-payment-submit">
            <div
                @click="submitPayment"
                data-test="submit-payment-button"
                id="checkout__button--submit-step-2"
                class="checkout__button checkout__button--submit-step-2"
                :class="buttonAdditionalClass"
                v-html="`${submitTitle} »`"></div>
        </portal>
    </div>
</template>

<script>
import 'ie-array-find-polyfill';
import { mapGetters, mapState } from 'vuex';
import braintree from 'braintree-web';
import axios from 'axios';
import msg from '../../../messages';
import { titleCase } from '../../../string-helper';
import { createToken } from '../../csrf';
import { getCardsSupportedByCurrency } from '../../../constants/currencies';

export default {
    props: {
        braintreeClientInstance: {
            required: true,
        },
        submitTitle: {
            required: true,
            type: String,
        },
        createPaymentMethodEndpoint: {
            default: 'create-payment-method',
            type: String,
        },
        createPaymentMethodFormData: {
            default() {
                return {};
            },
            type: Object,
        },
        isLifetimeUpdates: {
            required: false,
            default: false,
            type: Boolean,
        },
    },
    data: function () {
        return {
            creditCardAvailable: false,
            hostedFieldsInstance: null,
            hostedFieldsSetupAttempts: 0,
            threeDsecure: null,
            deviceData: null,
            cardType: null,
            fields: {
                number: {
                    style: {},
                    label: {
                        classObject: {
                            focus: false,
                            'not-empty': false,
                        },
                        style: {},
                        text: this.getFieldLabel('number'),
                    },
                },
                cvv: {
                    style: {},
                    label: {
                        classObject: {
                            focus: false,
                            'not-empty': false,
                        },
                        style: {},
                        text: this.getFieldLabel('cvv'),
                    },
                },
                expirationDate: {
                    style: {},
                    label: {
                        classObject: {
                            focus: false,
                            'not-empty': false,
                        },
                        style: {},
                        text: this.getFieldLabel('expirationDate'),
                    },
                },
            },
        };
    },
    computed: {
        hostedFieldsSetup() {
            return (
                this.$refs.hostedFieldCardNumber.hasChildNodes() &&
                this.$refs.hostedFieldExpirationDate.hasChildNodes() &&
                this.$refs.hostedFieldCvv.hasChildNodes()
            );
        },
        buttonAdditionalClass: function () {
            return {
                'checkout__button--small': this.submitTitle.length > 40 || window.App.language === 'es',
            };
        },
        ...mapState(['applePayAvailable', 'paymentType', 'currency', 'contact', 'is_sca', 'defaultPaymentMethodToken']),
        ...mapGetters(['formData', 'product']),
    },

    watch: {
        braintreeClientInstance: function () {
            this.setUp();
            this.setUpDataCollector();
            this.setUpThreeDsecure();
        },
    },

    mounted() {
        this.eventBus.on('MAKE_IMMEDIATE_CREDIT_CARD_PAYMENT', (token) => {
            this.$store.dispatch('immediatePayment', token);
        });

        this.eventBus.on('RETRY_CHECKOUT_PAYMENT_WITH_3D_SECURE', () => {
            this.$store.commit('setIsRetryAttempt', true);
            this.submitPayment();
        });

        this.eventBus.on('RETRY_IMMEDIATE_PAYMENT_WITH_3D_SECURE', () => {
            this.$store.commit('setIsRetryAttempt', true);
            this.retryImmediatePayment();
        });

        this.eventBus.on('RETRY_UPDATE_PAYMENT_WITH_3D_SECURE', () => {
            this.$store.commit('setIsRetryAttempt', true);
            this.submitPayment();
        });
    },

    methods: {
        setUpThreeDsecure() {
            braintree.threeDSecure
                .create({
                    client: this.braintreeClientInstance,
                    version: 2,
                })
                .then((threeDsecureInstance) => {
                    this.threeDsecure = threeDsecureInstance;
                    this.threeDsecure.on('customer-canceled', () => {
                        window.ipse.dispatch({
                            action: 'three_d_secure_cancelled',
                        });
                    });
                    this.threeDsecure.on('authentication-modal-close', () => {
                        window.ipse.dispatch({
                            action: 'three_d_secure_closed',
                        });
                    });
                    this.threeDsecure.on('authentication-modal-render', () => {
                        window.ipse.dispatch({
                            action: 'three_d_secure_viewed',
                        });
                    });
                })
                .catch((err) => {
                    logger.captureException(err);
                });
        },
        setUpDataCollector() {
            braintree.dataCollector
                .create({
                    client: this.braintreeClientInstance,
                })
                .then((collectorInstance) => {
                    this.$store.commit('setBraintreeDeviceData', collectorInstance.deviceData);
                })
                .catch((err) => {
                    logger.captureException(err);
                });
        },
        successfulToken(token) {
            this.$store.commit('setLastCheckoutPaymentMethod', 'credit-card');
            this.$emit('received-token', token);
        },
        async retryImmediatePayment() {
            try {
                this.$store.commit('increaseImmediatePaymentAttempts');
                this.$store.dispatch('immediatePayment', this.paymentMethodToken);
            } catch (err) {
                logger.captureException(new Error(msg.checkout.immediatePaymetRetryFailed), { extra: err });
            }
        },
        setUp() {
            const hostedFieldsOptions = {
                client: this.braintreeClientInstance,
                styles: {
                    input: {
                        'font-size': '16px',
                        'font-family': '"Open Sans", sans-serif',
                        'font-weight': '400',
                        color: '#4c4c4c',
                        border: '2px solid black',
                        padding: window.screen.width <= 320 ? '17px 20px 0px 14px' : '20px 20px 0px 14px',
                    },
                    ':focus': {
                        color: 'black',
                    },
                    '.invalid': {
                        color: '#d80c0c',
                    },
                    '.valid': {
                        color: 'green',
                    },
                    'input.tab-target': {
                        padding: '0!important',
                    },
                },
                fields: {
                    number: {
                        selector: '#card-number',
                        placeholder: '',
                        supportedCardBrands: getCardsSupportedByCurrency(this.currency),
                    },
                    cvv: {
                        selector: '#cvv',
                        placeholder: '',
                    },
                    expirationDate: {
                        selector: '#expiration-date',
                        placeholder: '',
                    },
                },
            };

            this.hostedFieldsSetupAttempts += 1;

            if (this.hostedFieldsSetupAttempts === 1) {
                logger.addCheckoutBreadcrumb({
                    message: msg.checkout.hostedFieldsSetupStarted,
                    data: { attempt: this.hostedFieldsSetupAttempts },
                });
            }

            // Timeout to check if hosted fields have setup.
            setTimeout(
                function () {
                    this.checkHostedFieldsSetup();
                }.bind(this),
                10000,
            );

            braintree.hostedFields
                .create(hostedFieldsOptions)
                .then((hostedFieldsInstance) => {
                    const vm = this;

                    logger.addCheckoutBreadcrumb({
                        message: msg.checkout.hostedFieldsSetupCompleted,
                        data: { attempt: this.hostedFieldsSetupAttempts },
                    });

                    hostedFieldsInstance.on('focus', function (event) {
                        vm.fields[event.emittedBy].label.classObject.focus = true;
                        vm.makeFieldNeutral(event.emittedBy);
                    });

                    hostedFieldsInstance.on('blur', function (event) {
                        vm.fields[event.emittedBy].label.classObject.focus = false;
                    });

                    hostedFieldsInstance.on('notEmpty', function (event) {
                        vm.fields[event.emittedBy].label.classObject['not-empty'] = true;
                    });

                    hostedFieldsInstance.on('empty', function (event) {
                        vm.fields[event.emittedBy].label.classObject['not-empty'] = false;
                    });

                    hostedFieldsInstance.on('validityChange', function (event) {
                        const field = event.fields[event.emittedBy];

                        if (!field.isValid && !field.isPotentiallyValid) {
                            vm.makeFieldInvalid(event.emittedBy);
                        } else if (!field.isValid && field.isPotentiallyValid) {
                            vm.makeFieldNeutral(event.emittedBy);
                        } else {
                            vm.makeFieldValid(event.emittedBy);
                        }
                    });

                    hostedFieldsInstance.on('cardTypeChange', function (event) {
                        if (event.cards.length === 1) {
                            vm.cardType = event.cards[0].type;
                            vm.checkCardIsSupported(vm.cardType);
                        } else {
                            vm.cardType = null;
                        }
                    });

                    this.hostedFieldsInstance = hostedFieldsInstance;
                    this.creditCardAvailable = true;
                })
                .catch(function (err) {
                    logger.captureException(err);
                });
        },
        paymentError() {
            this.$store.commit('setIsRetryAttempt', false);
            this.$store.dispatch('showPaymentErrorModal', 'credit-card');
            this.$store.commit('setProcessingCheckout', false);
            this.$store.commit('setProcessingImmediatePayment', false);
        },
        async submitPayment() {
            if (!this.creditCardAvailable) {
                // TODO: probably there is better way to handle this
                return false;
            }

            const fields = this.hostedFieldsInstance.getState().fields;
            const isValid = Object.keys(fields).every(function (field) {
                return fields[field].isValid;
            });

            if (!isValid) {
                Object.keys(fields).forEach(
                    function (field) {
                        if (!fields[field].isValid) {
                            this.makeFieldInvalid(field);
                        }
                    }.bind(this),
                );
                return;
            }

            let type;
            let commitType;
            let amount;

            if (this.createPaymentMethodEndpoint === 'update-payment-method-create') {
                commitType = 'increaseUpdatePaymentMethodAttempts';
                type = 'update_payment_method';
            } else {
                commitType = 'increaseCheckoutPaymentAttempts';
                type = 'checkout';

                window.ipse.dispatch({
                    action: 'submit_payment_clicked',
                    data_event: {
                        type: 'credit-card',
                    },
                });
            }

            this.$store.commit('setProcessingCheckout', true);
            this.$store.commit(commitType);

            if (type === 'update_payment_method') {
                this.$store.commit('setLastCheckoutPaymentMethod', 'credit-card');
                amount = '0';
            } else if (this.isLifetimeUpdates) {
                amount = this.product.price.lu.value;
            }

            let tokenizedFields;
            let nonceObject;
            let paymentMethodResponse;

            try {
                tokenizedFields = await this.hostedFieldsInstance.tokenize();
                logger.addCheckoutBreadcrumb({
                    message: msg.checkout.hostedFieldsTokenized,
                    data: { tokenizedFields },
                });
            } catch (err) {
                this.fail(type, 'hosted_fields_tokenize_failed', err);

                window.ipse.dispatch({
                    action: 'hosted_fields_tokenize_failed',
                    data_event: {
                        reason: 'hosted_fields_tokenize_failed',
                        purchase_flow: type,
                        error: err,
                    },
                });

                return;
            }

            try {
                nonceObject = await this.verifyCard(tokenizedFields.nonce, tokenizedFields.details.bin, amount);
            } catch (err) {
                this.fail(type, 'card_verification_failed', err);

                window.ipse.dispatch({
                    action: 'card_verification_failed',
                    data_event: {
                        reason: 'card_verification_failed',
                        purchase_flow: type,
                        error: err,
                    },
                });

                return;
            }

            try {
                paymentMethodResponse = await this.createPaymentMethod(nonceObject.nonce);
                logger.addCheckoutBreadcrumb({
                    message: msg.checkout.paymentMethodCreated,
                    data: { paymentMethodResponse },
                });
            } catch (err) {
                this.fail(type, 'create_payment_method_failed', err);

                window.ipse.dispatch({
                    action: 'create_payment_method_failed',
                    data_event: {
                        purchase_flow: type,
                        error: err,
                    },
                });

                return;
            }

            this.$store.commit('setCardDetails', {
                countryOfIssuance: paymentMethodResponse.data.country_of_issuance,
                issuingBank: paymentMethodResponse.data.issuing_bank,
                cardType: paymentMethodResponse.data.card_type,
                paymentMethodToken: paymentMethodResponse.data.token,
            });

            if (!paymentMethodResponse.data.subscriptions) {
                this.successfulToken(paymentMethodResponse.data.token);
                return;
            }

            this.$store.dispatch('updatePaymentMethod', {
                responseData: paymentMethodResponse.data,
            });
        },
        async createPaymentMethod(nonce) {
            const formData =
                Object.keys(this.createPaymentMethodFormData).length === 0
                    ? this.formData
                    : this.createPaymentMethodFormData;

            let tokenResponse = null;

            if (this.createPaymentMethodEndpoint === 'update-payment-method-create') {
                tokenResponse = await createToken('update-payment-method-create', '.checkout__content');
            }

            return axios.post(
                '/api/' + this.createPaymentMethodEndpoint,
                Object.assign({}, formData, {
                    nonce,
                    csrf_token: tokenResponse?.csrf_token,
                    recaptcha_token: tokenResponse?.recaptcha_token,
                }),
                {
                    headers: {
                        'x-transaction-id': logger.getTransactionId(),
                    },
                },
            );
        },
        verifyCard(nonce, bin, amount, email) {
            const vm = this;
            return new Promise((resolve, reject) => {
                function checkSecure() {
                    setTimeout(() => {
                        if (!vm.threeDsecure) {
                            checkSecure();
                        } else {
                            if (!vm.is_sca) {
                                window.ipse.dispatch({
                                    action: 'three_d_secure_omitted',
                                    data_event: {
                                        product: vm.product.slug,
                                        is_sca: vm.is_sca,
                                    },
                                });
                                resolve({ nonce });
                                return;
                            }

                            vm.threeDsecure
                                .verifyCard({
                                    onLookupComplete: function (data, next) {
                                        next();
                                    },
                                    amount: amount
                                        ? amount
                                        : vm.paymentType === 'now'
                                          ? vm.product.price.full.value
                                          : vm.product.price.plan.value,
                                    nonce: nonce,
                                    bin: bin,
                                    email: email ? email : vm.email,
                                    challengeRequested: true,
                                })
                                .then((payload) => {
                                    const liabilityShifted = payload.liabilityShifted;
                                    const liabilityShiftPossible = payload.liabilityShiftPossible;

                                    let status = 'not-present';
                                    try {
                                        status = payload.threeDSecureInfo.status;
                                    } catch (e) {}
                                    let countryOfIssuance = 'not-present';
                                    try {
                                        countryOfIssuance = payload.binData.countryOfIssuance;
                                    } catch (e) {}
                                    let issuingBank = 'not-present';
                                    try {
                                        issuingBank = payload.binData.issuingBank;
                                    } catch (e) {}
                                    let cardType = 'not-present';
                                    try {
                                        cardType = payload.details.cardType;
                                    } catch (e) {}

                                    vm.$store.commit('setVerifyDetails', {
                                        liabilityShifted,
                                        liabilityShiftPossible,
                                        verifyStatus: status,
                                    });

                                    const eventData = {
                                        event: 'card_3ds_verification_result',
                                        liabilityShifted,
                                        liabilityShiftPossible,
                                        status,
                                        product: vm.product.slug,
                                        countryOfIssuance,
                                        issuingBank,
                                        cardType,
                                        is_sca: vm.is_sca,
                                    };

                                    window.ipse.dispatch({
                                        action: 'three_d_secure_data_gathered',
                                        data_event: eventData,
                                    });

                                    if (liabilityShiftPossible && !liabilityShifted) {
                                        vm.$store.commit('setProcessingCheckout', false);
                                        vm.$store.commit('setProcessingImmediatePayment', false);
                                        vm.$store.commit('openCheckout', {
                                            step: 2,
                                            errorCode: 'credit-card-3-d-secure-error',
                                        });
                                    } else {
                                        resolve(payload);
                                    }
                                })
                                .catch((error) => {
                                    reject(error);
                                });
                        }
                    }, 10);
                }
                checkSecure();
            });
        },
        // We check if hosted fields have setup within 10 seconds, if not we retry setup.
        checkHostedFieldsSetup() {
            if (this.hostedFieldsSetup) {
                if (this.hostedFieldsSetupAttempts > 1) {
                    logger.addCheckoutBreadcrumb({
                        message: msg.checkout.hostedFieldsSetupCompleted,
                        data: { attempt: this.hostedFieldsSetupAttempts },
                    });
                }
            } else {
                if (this.hostedFieldsSetupAttempts < 5) {
                    logger.addCheckoutBreadcrumb({
                        message: msg.checkout.hostedFieldsSetupStarted,
                        data: { attempt: this.hostedFieldsSetupAttempts },
                    });

                    this.setUp();
                } else {
                    logger.captureException(new Error(msg.checkout.hostedFieldsSetupFailed), {
                        extra: { attempts: this.hostedFieldsSetupAttempts },
                    });
                }
            }
        },

        makeFieldInvalid(field) {
            this.fields[field].label.text = this.getFieldErrorMessage(field);
            this.fields[field].label.style = { color: '#d80c0c' };
            this.fields[field].style = { border: '1px solid #d80c0c' };

            this.fields[field].label.classObject.focus = true;
        },
        makeFieldNeutral(field) {
            this.fields[field].label.text = this.getFieldLabel(field);
            this.fields[field].label.style = { color: 'gray' };
            this.fields[field].style = { border: '1px solid #c5c5c5' };
        },
        makeFieldValid(field) {
            this.fields[field].label.text = this.getFieldLabel(field);
            this.fields[field].label.style = { color: 'green' };
            this.fields[field].style = { border: '1px solid green' };

            if (field === 'number') {
                this.hostedFieldsInstance.focus('expirationDate');
                this.tracker.fireAddPaymentInfoEvent();
            } else if (field === 'expirationDate') {
                this.hostedFieldsInstance.focus('cvv');
            }
        },

        getFieldLabel(field) {
            switch (field) {
                case 'number':
                    return `${this.$t('checkout.creditCardNumber')}`;
                case 'cvv':
                    return `${this.$t('checkout.cvv')} (CVV)`;
                case 'expirationDate':
                    return (
                        `<span class="hosted-field--exp-date-desktop">${this.$t('checkout.expirationDate')}</span>` +
                        `<span class="hosted-field--exp-date-mobile">${this.$t('checkout.expDate')}</span>`
                    );
            }
        },
        getFieldErrorMessage(field) {
            switch (field) {
                case 'number':
                    return this.$t('checkout.enterValidCreditCard');
                case 'cvv':
                    return this.$t('checkout.enterValidCVV');
                case 'expirationDate':
                    return this.$t('checkout.enterValidExpirationDate');
            }
        },
        isCardSupported(card) {
            if (card === 'master-card') {
                card = 'mastercard';
            }

            const cards = getCardsSupportedByCurrency(this.currency);

            return cards[card];
        },

        checkCardIsSupported(card) {
            if (this.isCardSupported(card)) {
                return;
            }

            logger.captureException(new Error(msg.checkout.unsupportedCreditCard), {
                tags: {
                    cardType: card,
                    currency: this.currency,
                },
            });
        },

        fail(type, event, err) {
            this.paymentError();
            logger.captureException(new Error(titleCase(event)), { extra: err });
        },
    },
};
</script>
